import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
})
export class LogoComponent {
  @Input() logoTheme: 'navy' | 'white';
  @Input() route?: string;
  @Input() logoUrl;

  constructor(private readonly router: Router) {}

  navigate() {
    this.router.navigate([this.route ? this.route : '']);
  }
}
